import { Text } from 'react-native';

export function SidebarEmptyHint({ message }: { message: string }) {
  return <Text className="px-3 py-1 text-[11px] text-muted">{message}</Text>;
}
